module.exports = __webpack_public_path__ + "img/icon_jinbi.f7c82971.png";